import { TypographyBodySize } from "../../../../styles/typography/typography";
import { ButtonSize } from "../types";

export const sizeToTypographyBodySizeMap: {
  [key in ButtonSize]: TypographyBodySize;
} = {
  small: "small",
  standard: "medium"
};
